'use client'

import { batch } from '@preact/signals-react'
import { useSignals } from '@preact/signals-react/runtime'
import { useClientNav } from '@susu/headless-commerce/features/navigation/components/ClientNavProvider'
import { enableScroll } from '@susu/headless-commerce/utils/scrollUtils'
import classNames from 'classnames'
import { useCallback } from 'react'
import styles from './NavOverlay.module.scss'

export type ClientNavOverlayProps = {
  className?: string
}

export const ClientNavOverlay = ({ className }: ClientNavOverlayProps) => {
  useSignals()

  const { closeNav, closeSubMenu } = useClientNav()

  const handleClick = useCallback(() => {
    batch(() => {
      closeSubMenu()
      closeNav()
      enableScroll()
    })
  }, [closeNav, closeSubMenu])

  const navOverlayClass = classNames(
    styles['nav-overlay'],
    'nav-overlay',
    className,
  )

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div
      className={navOverlayClass}
      onClick={handleClick}
      data-testid="nav-overlay"
    />
  )
}
